import EmployeesView from "../EmployeesView.vue";
import EmployeeList from "../Pages/EmployeeList.vue";
import EmployeeDetails from "../Pages/EmployeeDetails.vue";
import EmployeeEditor from "../Pages/EmployeeEditor.vue";
import BulkUploadPage from "../Pages/BulkUploadPage.vue";
import FamilyBulkUpload from "../Pages/FamilyBulkUpload.vue";

const routes = [
  {
    path: '/colaboradores',
    component: EmployeesView,
    children: [
      {
        path: '',
        name: 'employee-list',
        component: EmployeeList,
      },
      {
        path: 'carga-masiva',
        name: 'employee-bulk-upload',
        component: BulkUploadPage,
      },
      {
        path: 'carga-masiva-familiares',
        name: 'family-bulk-upload',
        component: FamilyBulkUpload,
      },
      {
        path: ':id/detalle',
        name: 'employee-details',
        component: EmployeeDetails,
      },
      {
        path: 'crear',
        name: 'employee-create',
        component: EmployeeEditor,
      },
      {
        path: ':id',
        name: 'employee-edit',
        component: EmployeeEditor,
      },
    ]
  }
]

export default routes
